export function mergeAndSumData(dataArray) {
  return dataArray.reduce(
    (acc, item) => {
      acc.historyCurrent = [...acc.historyCurrent, ...item.historyCurrent];

      acc.numberOfAnomaly += item.numberOfAnomaly || 0;
      acc.numberOfStars += item.numberOfStars || 0;
      acc.numberOfPackmat += item.numberOfPackmat || 0;
      acc.totalVolumeSortingError += item.totalVolumeSortingError || 0;
      acc.totalWasteVolume += item.totalWasteVolume || 0;
      acc.collectionFillingLevel += item.collectionFillingLevel || 0;
      acc.numberOfObjects += item.numberOfObjects || 0;

      Object.entries(item.anomalyDelivery || {}).forEach(([key, val]) => {
        acc.anomalyDelivery[key] = (acc.anomalyDelivery[key] || 0) + val;
      });

      Object.entries(item.objectDelivery || {}).forEach(([key, val]) => {
        acc.objectDelivery[key] = (acc.objectDelivery[key] || 0) + val;
      });

      return acc;
    },
    {
      historyCurrent: [],
      numberOfAnomaly: 0,
      numberOfStars: 0,
      anomalyDelivery: {},
      numberOfPackmat: 0,
      totalVolumeSortingError: 0,
      totalWasteVolume: 0,
      collectionFillingLevel: 0,
      objectDelivery: {},
      numberOfObjects: 0,
    },
  );
}

export const buildObjectData = (objectDelivery, handleAnomalyList) => {
  if (!objectDelivery)
    return { objectColors: [], objectNames: [], objectCount: [] };

  const objectList = handleAnomalyList(objectDelivery);
  const mergedMaterials = objectList.flat().reduce((merged, material) => {
    merged[material.name] = {
      ...(merged[material.name] || { ...material }),
      count: (merged[material.name]?.count || 0) + material.count,
    };
    return merged;
  }, {});

  const mergedArray = Object.values(mergedMaterials);
  return {
    objectColors: mergedArray.map((m) => m.color),
    objectNames: mergedArray.map((m) => m.name),
    objectCount: mergedArray.map((m) => m.count),
    // Untranslated material key (e.g. "cardboard"), used to match the `cls`
    // field of individually detected objects (see useMaterialObjectsZoom).
    objectValues: mergedArray.map((m) => m.value),
  };
};

// Nombre de vignettes "relevés en erreur" affichées : 8 par défaut, mais on en
// montre davantage (jusqu'à 24) quand beaucoup de relevés ont des erreurs de
// tri, proportionnellement au nombre de relevés concernés (30% d'entre eux).
const ANOMALY_DISPLAY_MIN = 8;
const ANOMALY_DISPLAY_MAX = 24;
const ANOMALY_DISPLAY_RATIO = 0.3;

export const getFilteredAnomalies = (history = []) => {
  const anomalousRecords = history.filter((item) => item.anomalies > 0);
  const displayCount = Math.min(
    ANOMALY_DISPLAY_MAX,
    Math.max(
      ANOMALY_DISPLAY_MIN,
      Math.ceil(anomalousRecords.length * ANOMALY_DISPLAY_RATIO),
    ),
  );

  return anomalousRecords
    .sort((a, b) => b.anomalies - a.anomalies)
    .slice(0, displayCount)
    .sort((a, b) => new Date(b._time) - new Date(a._time));
};

export const starsCalculation = (totalVolumeSortingError, totalWasteVolume) => {
  let numberOfStars = 3;
  if (totalVolumeSortingError > 0 && totalWasteVolume > 0) {
    if (totalVolumeSortingError / totalWasteVolume < 0.05) {
      numberOfStars = 3;
    } else if (totalVolumeSortingError / totalWasteVolume < 0.15) {
      numberOfStars = 2;
    } else if (totalVolumeSortingError / totalWasteVolume < 0.3) {
      numberOfStars = 1;
    } else {
      numberOfStars = 0;
    }
  } else {
    numberOfStars = 3;
  }
  return numberOfStars;
};
